import { Trans } from 'react-i18next';

import { actions } from 'entities';

import { Alert, Button, Column, LabeledTextarea } from 'components/Blocks';
import { EntitySelect } from 'components/Entities';
import { FolderSyncIcon, InfoIcon } from 'components/Icons';

import { useFormControlV2, useLang } from 'hooks';
import { useProjectProfile } from '../../context';

import { sortByName } from 'utils/array';
import {
  isValidJustification,
  RequiredJustificationAlert,
} from 'components/RequiredJustificationAlert';

export function RequestChangeForm() {
  const { t } = useLang();
  const { project, updateProject } = useProjectProfile();

  const [state, handlers] = useFormControlV2({
    team: '',
    justification: '',
  });

  const canSubmit =
    Object.values(state).every((x) => x.trim()) && isValidJustification(state.justification);

  const requestChange = actions.projects.requestTeamChange.use({
    block: !canSubmit,

    params: {
      ...state,
      projectId: project.id,
    },

    onSuccess: (request) =>
      updateProject((old) => ({
        ...old,
        teamChangeRequest: {
          id: request.id,
          toTeam: state.team,
        },
      })),
  });

  return (
    <Column gap="6">
      <Alert
        level="info"
        className="items-start"
        type="lightly-filled"
        icon={<InfoIcon className="translate-y-1" />}
      >
        <Trans i18nKey={'change-team-alert'} />
      </Alert>

      <EntitySelect
        label={t('team-responsible')!}
        id="team"
        target="teams.list"
        labelKey="name"
        value={state.team}
        onChange={handlers.handleChange}
        fullWidth
        parser={(list) =>
          sortByName(list.filter((t) => t.canAssumeProject && t.id !== project.teamResponsible))
        }
      />

      <LabeledTextarea
        label={t('justification')!}
        id="justification"
        value={state.justification}
        onChange={handlers.handleChange}
        fullWidth
      />

      <RequiredJustificationAlert text={state.justification} />

      <Button disabled={!canSubmit} variant="outlined" {...requestChange.buttonProps}>
        <FolderSyncIcon />
        {t('request-team-change')}
      </Button>
    </Column>
  );
}
